import React, { useContext } from 'react';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import DropDownSingle from '../../../../Components/DropDownSingle';
import PageHeading from '../../../../Components/PageHeading';

import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';


const PLACEMENT_VALUES = [
	{ label: '1', value: '1' },
	{ label: '4', value: '4' }
];
/**
 * @name CustomPlacementParam
 * @description This component is an editor for customPlacementParam
 * ```
 * {
 *   "customPlacementParam": {
 *     "configs": [
 *       {
 *         "placementValue": "4",
 *         "splitPercentage": 100
 *       }
 *     ],
 *     "enabled": true
 *   }
 * }
 * ```
 * @param {{keyData: 'experimentalFeaturesData.customPlacementParam'}} keyData - A key used to identify the configuration in the `rawConfig` object.
 */
const CustomPlacementParam = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const customPlacementParamConfigKey = keyData + '.configs';

	const updatePlacementValueConfig = (value) => {
		const clonedConfig = structuredClone(rawConfig);

		clonedConfig[customPlacementParamConfigKey] = clonedConfig[customPlacementParamConfigKey] || [
			{ placementValue: '', splitPercentage: 100 }
		];

		clonedConfig[customPlacementParamConfigKey][0].placementValue = value;
		updateRawConfig(clonedConfig);
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Custom Placement Param"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Custom Placement Param']}
				description="Manage Custom Placement Param Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container style={{ marginTop: '4rem', width: '94%', marginLeft: '5rem' }}>
				<Grid item xs={3}>
					<CheckboxInput
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						style={{ marginTop: '3rem' }}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<DropDownSingle
						label="Placement Value"
						isObjectEditor={false}
						keyData={customPlacementParamConfigKey + '.0.placementValue'}
						formControlVariant="outlined"
						directValue={rawConfig?.[customPlacementParamConfigKey]?.[0]?.placementValue}
						updateDirectValue={(updatePlacementValue) =>
							updatePlacementValueConfig(updatePlacementValue)
						}
						list={PLACEMENT_VALUES}
						disabled={!rawConfig?.[keyData + '.enabled']}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default CustomPlacementParam;
